import {PropsWithChildren, useEffect, useState} from "react";
import './dropdownbox.scss';
import IconDown from '../../../assets/icons/UI/select/arrow-down.svg';
import IconUp from '../../../assets/icons/UI/select/arrow-up.svg';

interface DropdownProps {
  title: string,
  defaultOpened?: boolean
}

const Dropdown = (props: PropsWithChildren<DropdownProps>) => {
  const {
    title,
    defaultOpened,
    children
  } = props;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (typeof defaultOpened === 'boolean') {
      setIsOpen(defaultOpened);
    }
  }, [defaultOpened])

  return <div className={'dropdownbox'}>
    <div className={'dropdownbox-title'}>
      <span className={'dropdownbox-title-text'}>
        {title}
      </span>
      <div className={'dropdownbox-title-line'}/>
      <img
        src={isOpen ? IconUp : IconDown}
        alt={isOpen ? 'close-arrow' : 'open-arrow'}
        className={'dropdownbox-title-arrow'}
        onClick={() => setIsOpen(!isOpen)}
      />
    </div>

      {
        isOpen
          ? <div className={'dropdownbox-children'}>
            {children}
          </div>
          : null
      }
  </div>
}

export default Dropdown;